// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yqyibrhwvmcuxenyamrs.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlxeWlicmh3dm1jdXhlbnlhbXJzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMyMTEyNjAsImV4cCI6MjA2ODc4NzI2MH0.EtygFaAIcHr-TSPVgou-BC_zv9IGChNnNKlbePbDaLo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});